// extracted by mini-css-extract-plugin
export default {"View":"view_View__j3u1T","Actions":"view_Actions__1VMZw"};